export default __webpack_public_path__ + "static/media/dessert2.3c582254.jpg";